import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { RefundAmountField, RefundCategoryField, RefundReasonField, OpenBalancesSwitch, OpenClaimsSwitch, CreditCardRefundSwitch, EscalateSwitch } from '../fieldEditors/refundDetails';
import SectionPaper from '../../../common/components/styled-ui-elements/SectionPaper';

export const RefundDetailsSection: React.FC = () => (
  <SectionPaper>
    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
      Refund Details
    </Typography>
    <Stack spacing={2}>
      <Stack direction="row" spacing={2}>
        <RefundAmountField />
        <RefundCategoryField />
      </Stack>
      <RefundReasonField />
      
      <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #e2e8f0' }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1e293b', mb: 1 }}>
          Options
        </Typography>
        <Stack direction="row" spacing={3} flexWrap="wrap">
          <OpenBalancesSwitch />
          <OpenClaimsSwitch />
          <CreditCardRefundSwitch />
          <EscalateSwitch />
        </Stack>
      </Box>
    </Stack>
  </SectionPaper>
);

export default RefundDetailsSection;
